<template>
  <page-content v-has-permission="'system_config_properties_view'">

    <panel ref="searchFormPanel" :is-open.sync="showFormSearch" show-close show-collapse title="Thông tin tìm kiếm">
      <c-form ref="searchForm" @submit="search()">

        <b-row>
          <c-input v-model.trim="searchForm.application" form-group-class="col-md-6 col-sm-6" label="Application"/>
          <c-input v-model.trim="searchForm.profile" form-group-class="col-md-6 col-sm-6" label="Profile"/>
          <c-input v-model.trim="searchForm.label" form-group-class="col-md-6 col-sm-6" label="Label"/>
          <c-input v-model.trim="searchForm.key" form-group-class="col-md-6 col-sm-6" label="Key"/>
          <c-input v-model.trim="searchForm.value" form-group-class="col-md-6 col-sm-6" label="Value"/>
          <c-select2 v-model.number="searchForm.isActive"
                     label="Đang hoạt động"
                     form-group-class="col-md-6 col-sm-6"
          >
            <option value="true">true</option>
            <option value="false">false</option>
          </c-select2>
        </b-row>

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success" type="submit">
              <i class="fas fa-search"></i> Tìm kiếm
            </button>
            <button class="btn btn-secondary" type="reset" @click="resetFormSearch()">
              <i class="fas fa-redo-alt"></i>
              Xóa bộ lọc
            </button>
          </b-col>
        </b-row>
      </c-form>
    </panel>

    <panel ref="panel" show-collapse title="Danh sách hành động">
      <template #btn>
        <li>
          <a v-b-tooltip.hover title="Load lại dữ liệu" @click="$refs.table.reload()">
            <i class="fas fa-sync-alt"></i>
          </a>
        </li>
        <li>
          <a v-b-tooltip.hover title="Hiển thị thông tin tìm kiếm" @click="showFormSearch = !showFormSearch">
            <i class="fas fa-search"></i>
          </a>
        </li>
      </template>
      <c-table ref="table"
               :data-filter="searchForm"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'Application', sortField:'application', sortable: true},
                   {text: 'Profile', sortField:'profile', sortable: true},
                   {text: 'Label', sortField:'label', sortable: true},
                   {text: 'Key', sortField:'key', sortable: true},
                   {text: 'Value', sortField:'value', sortable: true},
                   {text: 'Đang hoạt động', sortField:'isActive', sortable: true},
                   {text: 'Thao tác', width: '200px'},
               ]"
               uri="/cms/api/v1.0/system-config-properties/get-all"
               :page-size="100"
      >
        <template #button>
          <b-button v-if="hasPermission('system_config_properties_create')"
                    size="sm"
                    variant="success"
                    @click="$refs.formCreate.open()"
          >
            <i class="fas fa-plus-circle"></i> Thêm mới
          </b-button>
        </template>
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td>{{ item.application }}</td>
          <td>{{ item.profile }}</td>
          <td>{{ item.label }}</td>
          <td><code>{{ item.key }}</code></td>
          <td style="max-width: 565px; text-overflow: ellipsis; overflow: hidden; cursor: pointer"
              :title="item.value"
              @click="copyText(item.value)"
          >
            {{ item.value }}
          </td>
          <td>{{ item.isActive }}</td>
          <td class="text-center">
            <b-button
                class="btn btn-icon"
                title="Copy System env"
                type="button"
                variant="info"
                @click="copySysEnv(item)"
            >
              <i class="fab fa-windows"></i>
            </b-button>

            <b-button
                class="btn btn-icon"
                title="Copy cấu hình spring"
                type="button"
                variant="info"
                @click="copySpringEnv(item)"
            >
              <i class="far fa-copy"></i>
            </b-button>

            <b-button
                class="btn btn-icon"
                title="Duplicate"
                type="button"
                variant="info"
                @click="clone(item)"
            >
              <i class="fad fa-clone"></i>
            </b-button>

            <b-button
                v-if="hasPermission('system_config_properties_update')"
                class="btn btn-icon"
                title="Sửa"
                type="button"
                variant="warning"
                @click="update(item)"
            >
              <i class="fas fa-pencil"></i>
            </b-button>

            <b-button
                v-if="hasPermission('system_config_properties_delete')"
                class="btn btn-icon"
                title="Xóa"
                type="button"
                variant="danger"
                @click="deleteItem(item)"
            >
              <i class="far fa-trash-alt"></i>
            </b-button>
          </td>
        </template>
      </c-table>
    </panel>

    <add ref="formCreate" @success="search()"/>
    <update ref="formUpdate" @success="search()"/>
    <delete ref="deleteConfirmDialog" @success="search()"/>
  </page-content>
</template>

<script>
import Add from './Add';
import Update from './Update';
import Delete from './Delete';

export default {
  name: "Index",
  components: {
    Add,
    Update,
    Delete,
  },
  data() {
    return {
      searchForm: {
        application: null,
        profile: null,
        label: null,
        key: null,
        value: null,
        isActive: null
      },
      showFormSearch: true,
    }
  },
  methods: {
    search() {
      this.$refs.table.reload();
    },
    resetFormSearch() {
      this.searchForm.application = null;
      this.searchForm.profile = null;
      this.searchForm.label = null;
      this.searchForm.key = null;
      this.searchForm.value = null;
      this.searchForm.isActive = null;

      this.search();
    },
    update(item) {
      this.$refs.formUpdate.open(item.id);
    },
    deleteItem(item) {
      this.$refs.deleteConfirmDialog.open(item);
    },
    clone(item) {
      this.$refs.formCreate.open(item)
    },
    copySysEnv(item) {
      var text = `${item.key?.replaceAll(".", "_").replaceAll("-", "").toUpperCase()}=${item.value}`;
      navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!');
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    },
    copySpringEnv(item) {
      var text = `${item.key}=${item.value}`;
      navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!');
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    },
    copyText(text){
      navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!');
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    }
  }
}
</script>

<style scoped>

</style>